import {
  IconSystemEdit,
  IconSystemImage,
  IconSystemNumberField,
  IconSystemEnvelope,
  IconSystemRude,
  IconSystemTextField,
  IconSystemAvatar,
  IconSystemCalendar,
  IconSystemBirthday,
  IconSystemBalloons,
  IconSystemGroup,
  IconSystemFaceHappy,
  IconSystemBrush,
  IconSystemAddressBook,
  IconSystemCards,
  IconSystemPalette,
  IconSystemBrand,
  IconSystemGlobe,
  IconSystemLetterbox,
  IconSystemGrid,
  IconSystemCurrencyPound,
  IconSystemCurrencyEuro,
  IconSystemCurrencyAuDollar,
  IconSystemCurrencyDollar,
  IconSystemHamper,
  IconSystemFlowers,
  IconSystemStarOutline,
  IconSystemPlussparkle,
  IconSystemSender,
  IconSystemOffer,
} from '@moonpig/launchpad-assets'
import React from 'react'

export const FILTER_ICONS: {
  [key: string]: React.JSX.Element
} = {
  IconSystemImage: <IconSystemImage />,
  IconSystemEdit: <IconSystemEdit />,
  IconSystemNumberField: <IconSystemNumberField />,
  IconSystemEnvelope: <IconSystemEnvelope />,
  IconSystemRude: <IconSystemRude />,
  IconSystemTextField: <IconSystemTextField />,
  IconSystemAvatar: <IconSystemAvatar />,
  IconSystemCalendar: <IconSystemCalendar />,
  IconSystemBirthday: <IconSystemBirthday />,
  IconSystemBalloons: <IconSystemBalloons />,
  IconSystemGroup: <IconSystemGroup />,
  IconSystemFaceHappy: <IconSystemFaceHappy />,
  IconSystemBrush: <IconSystemBrush />,
  IconSystemAddressBook: <IconSystemAddressBook />,
  IconSystemCards: <IconSystemCards />,
  IconSystemPalette: <IconSystemPalette />,
  IconSystemBrand: <IconSystemBrand />,
  IconSystemGlobe: <IconSystemGlobe />,
  IconSystemLetterbox: <IconSystemLetterbox />,
  IconSystemGrid: <IconSystemGrid />,
  IconSystemCurrencyPound: <IconSystemCurrencyPound />,
  IconSystemCurrencyEuro: <IconSystemCurrencyEuro />,
  IconSystemCurrencyAuDollar: <IconSystemCurrencyAuDollar />,
  IconSystemCurrencyDollar: <IconSystemCurrencyDollar />,
  IconSystemHamper: <IconSystemHamper />,
  IconSystemFlowers: <IconSystemFlowers />,
  IconSystemStarOutline: <IconSystemStarOutline />,
  IconSystemPlussparkle: <IconSystemPlussparkle />,
  IconSystemSender: <IconSystemSender />,
  IconSystemOffer: <IconSystemOffer />,
}
